import React from "react";
import { Provider } from "react-redux";
import { CategoryTopProductResult } from "~/common/Store/models/Category";
import Store from "~/common/Store";
import TopProductsGridMember from "./TopProductsGridMember";
import NotificationCenter from "~/common/Notification/NotificationCenter";
import("./productGrid.scss");
interface Props {
  topProducts: CategoryTopProductResult[];
}
const TopProductsGrid = ({
  topProducts
}: Props) => <>
    {!!topProducts?.length && <Provider store={Store}>
        <p className="header-3">Top Products</p>
        <NotificationCenter />
        <div className="ag-mini box" data-testid="gridWrapper" data-feature-name="Category - Top Products Grid" data-gtm-component="grid" gtm-carousel-name="Top Products">
          {topProducts.map(topProduct => topProduct && <TopProductsGridMember topProduct={topProduct} />)}
        </div>
      </Provider>}
  </>;
export default TopProductsGrid;